import { v4 as uuidv4 } from 'uuid';
import i18n from '../../../i18n';
import KizMarkGridPluginSettings from './KizMarkGridPluginSettings';
import KizMarkGrid from './KizMarkGrid';

export const KizMarkTab = (docNum?: string): ITab => {
    return {
        id: uuidv4(),
        title: i18n.t("sidePanel.accounting.submenu.kizMark"),
        view: {
            content: KizMarkGridPluginSettings
            ? <KizMarkGrid gridId={uuidv4()} plugin={KizMarkGridPluginSettings} data={{ 
                query: docNum ?? '', 
                option: docNum ? "docNum" : '', 
                initLoad: docNum ? false : true }}/>
            : <p> Справочник не настроен </p>
        }
    }
}

export default KizMarkTab